import { Theme } from '@mui/material/styles'

export const styles = {
  closedWonQueueLink: {
    textAlign: 'right',
  },

  pagination: {
    marginTop: (theme: Theme) => theme.spacing(1.5),
  },

  select: {
    marginBottom: (theme: Theme) => theme.spacing(1.2),
  },
}
